export default class Cards {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
